import React, { useEffect, useState } from 'react';
import * as toolbox from 'components/common/toolbox';
import * as actions_admin from 'actions/admin-actions';
import { Ibox, Input, Select, Textarea, Checkbox, ModalForm, Spinner } from 'enspire-manager-framework';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';

const _ = require('lodash');

export default function EmailBlast() {

    /* Hooks --------------------------*/

    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const routeLocation = useLocation();
    const admin = useSelector((store) => store.admin);
    const companySettings = useSelector((store) => store.settings.settings_company);
	const departments = useSelector((store) => store.settings.departments);
    const [modalShow, setModalShow] = React.useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [values, setValues] = useState({});

    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        subject: '',
        message: '',
        recipients: '',
        classType: '',
        title: '',
        departmentId: '',
    });

    useEffect(() => {
        if (params.message_id && admin.messages?.length) {
            const message = _.find(admin.messages, { id: params.message_id });
            setState(prev => ({
                ...prev,
                title: message?.title ?? '',
                subject: message?.subject ?? '',
                message: message?.message ?? '',
                recipients: message?.recipients ?? '',
            }));
        }
    }, [admin.messages, params.message_id]);
    
    /* Actions --------------------------*/

    const handleChange = (event) => {
        setState(prev => ({ ...prev, [event.target.name]: event.target.value }));
    };

    const handleCheckAll = () => Object.keys(values).map((name) => setValues(prev => ({ ...prev, [name]: { ...prev[name], checked: true } })));
    const handleUncheckAll = () => Object.keys(values).map((name) => setValues(prev => ({ ...prev, [name]: { ...prev[name], checked: false } })));

    const previewEmail = () => {
        
        if (state.title && state.recipients && state.subject && state.message) {

            if (params.message_id == '0') saveMessage();
            setLoading(true);
            dispatch(actions_admin.getBlastContacts(params.handle, state.recipients, state.departmentId, (contactList) => {
                let namesArray = [];
                
                var newValues = {};
                contactList.filter((contact) => !(contact.email == "opted-out" && contact.phone == "opted-out")).forEach((contact, index) => {
                    namesArray.push(contact.name);
                    newValues[contact.name] = { ...contact, checked: true };
                });
                setValues(newValues);

                var contactTable = [];
                namesArray.map((name, index) => {
                    index += 1;
                    const rowIndex = (index % 2) ? Math.round(index / 2) - 1 : Math.round((index - 1) / 2) - 1;
                    if (!contactTable[rowIndex]) contactTable[rowIndex] = [];
                    contactTable[rowIndex].push(name);
                });
                setDataTable(contactTable);
                setLoading(false);
                setModalShow(true);
            }));
            
        } else {
            window.toastr.error('Form not complete.', 'Form Not Complete!');
        }
    };
    
    const handleSend = () => {
        const contacts = Object.keys(values).map((name) => values[name]).filter((contact) => contact.checked).map((contact) => {
            delete contact.checked;
            return contact;
        });

        if (contacts.length < 1) {
            window.toastr.error("No recipients selected", "Notifications Not Sent!");
            return;
        }
        dispatch(actions_admin.sendNotificationBlast(params.handle, params.message_id, companySettings, contacts, state.subject, 
            state.message, () => {
                if (params.message_id == '0') saveMessage();
                setModalShow(false);
            }
        ));
    };
    
    // Clear Message
    const cancelMessage = () => {
        setState({
            subject: '',
            message: '',
            recipients: '',
            title: '',
            departmentid: '',
        });

        let location = toolbox.modifyPath(routeLocation.pathname, 3, '', 2);
        (params.message_id) && history.push({ pathname: location });
    };

    const saveMessage = async () => {
        let docId = params.message_id;
        const handle = params.handle;

        if (!state.title || !state.subject || !state.recipients || !state.message) {
            window.toastr.error('Form not complete.', 'Form Not Complete!');
            return;
        }

        dispatch(actions_admin.saveMessage(handle, state, docId, (messageId) => {
            if (params.message_id == '0') {
                history.push(`/${params.handle}/dashboard/${messageId}`);
            }
        }));
    };


    const departmentsOptions = departments.map((department, index) => {
        return (
			<option key={department.id} value={department.id}>{toolbox.toProperCase(department.value)}</option>
        );
    });

    return (
        <>
            { params.message_id &&
                <Ibox
                    key="email-blast"
                    className="mt-3"
                    title={'Email/SMS Message'}
                    show_spinner={admin.messages_save_pending}
                    no_fade={true}
                    styleContent={{ padding: '15px 10px' }} 
                    button={'Cancel'}
                    button_class={'btn btn-sm btn-default'}
                    button_callback={cancelMessage}
                >
                    <div className="row">
                        <div className="col-12">
                            <Input label="Title *" name="title" type="text" onChange={handleChange} value={state.title} placeholder={"e.g. Forester Update Message"} />
                            <Input label="Subject *" name="subject" type="text" onChange={handleChange} value={state.subject} placeholder={"e.g. Forester Update"} />
                            <Textarea label="Message *" name="message" rows="8" onChange={handleChange} value={state.message} placeholder={"e.g. Hey Foresters,\r\n\r\nThis is my message..."} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Select label="Recipients *" name="recipients" onChange={handleChange} value={state.recipients}>
                                <option value="">- Choose -</option>
                                <option value="employees">Employees</option>
                            </Select>
                        </div>
                        { (state.recipients == 'employees') &&
                            <div className="col-12">
                                <Select noLabel name="departmentId" onChange={handleChange} value={state.departmentId}>
                                    <option value="">All Departments</option>
                                    { departmentsOptions }
                                </Select>
                            </div>
                        }
                    </div>
                    <div className="row">
                        <div className="col-12">
                            { loading
                                ?   <div className="mb-5"><Spinner center /></div>
                                :    <button className={'btn btn-primary mt-4 w-100'} onClick={previewEmail}>
                                        Preview Recipients
                                        {state.rendering &&
                                            <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                        }
                                    </button>
                            }
                        </div>
                        <div className="col-12">
                            <button className={'btn btn-primary btn-outline mt-3 w-100'} onClick={saveMessage}>Save</button>
                        </div>
                    </div>
                </Ibox>
            }
            { modalShow &&
                <ModalForm
                    modal_header="Send Email, SMS, & Push Notifications?"
                    save_button_title={'Yes, send notifications!'}
                    cancel_button_callback={() => setModalShow(false)}
                    confirm_button_callback={handleSend}
                    style={ 1 }
                >
                    <a className="btn btn-primary btn-sm float-right ml-3 mt-4" onClick={handleUncheckAll}> Un-Check All</a>
                    <a className="btn btn-primary btn-sm float-right ml-3 mt-4" onClick={handleCheckAll}>Check All</a>
                    <h1 className="mb-4">Select Recipients</h1>

                    <table className='table table-sm'>
                        <tbody>
                            {
                                dataTable.map((row, rowIndex) =>
                                    <tr className='row' key={`${row}-${rowIndex}`}>
                                        {row.map((name, cellIndex) =>
                                            <td className='col-6 px-5' key={`${name}-${cellIndex}`}>
                                                <div onClick={() => setValues(prev => ({ ...prev, [name]: {...prev[name], checked: !values[name].checked} }))}>
                                                    <Checkbox className='mr-3' checked={values[name]?.checked} ></Checkbox>
                                                    <label>{name} &nbsp;</label>
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </ModalForm>
            }
        </>
    );
}


